import { Link } from 'react-router-dom'
import { Seo, DEFAULT_OG_IMAGE } from '../components/Seo'

const POLICY_VERSION = '1.1'
const POLICY_EFFECTIVE_DATE = '18 июля 2026 года'

export const sections: Array<{ heading: string; paragraphs: string[] }> = [
  {
    heading: '1. Общие положения',
    paragraphs: [
      'Настоящая Политика конфиденциальности определяет порядок обработки и защиты информации пользователей сервиса Fravai.',
      'Авторизуясь и используя Сервис, Пользователь подтверждает, что ознакомился с настоящей Политикой. Обработка данных, необходимая для работы Сервиса, осуществляется для заключения и исполнения договора с Пользователем, выполнения требований законодательства, обеспечения безопасности и реализации законных интересов Сервиса при условии соблюдения прав Пользователя.'
    ]
  },
  {
    heading: '2. Какие данные мы обрабатываем',
    paragraphs: [
      'Данные аккаунта, используемые для авторизации в Сервисе: идентификатор аккаунта, имя, адрес электронной почты, имя пользователя и изображение профиля, если соответствующий способ авторизации передал эти данные.',
      'Информацию об оплатах: факт оплаты, сумму, статус платежа, адрес электронной почты и иные технические данные платежа. Реквизиты банковских карт Сервисом не хранятся и не обрабатываются.',
      'Изображения, загружаемые Пользователем для генерации и обработки.',
      'Результаты генерации, созданные по запросу Пользователя.',
      'Текстовые запросы, пожелания и параметры генерации, которые Пользователь передает Сервису.',
      'Технические данные, включая IP-адрес, тип устройства, браузер, операционную систему, cookies и сведения об использовании Сервиса.',
      'Обращения в поддержку, включая текст сообщений и приложенные материалы.'
    ]
  },
  {
    heading: '3. Цели обработки информации',
    paragraphs: [
      'Предоставление доступа к функциям Сервиса.',
      'Выполнение генерации изображений и обработка запросов Пользователя.',
      'Прием оплаты, учет операций и направление электронных чеков.',
      'Техническая поддержка Пользователей.',
      'Обеспечение стабильной и безопасной работы Сервиса.',
      'Анализ и улучшение качества работы Сервиса.',
      'Направление технических уведомлений о генерациях, платежах, безопасности и состоянии аккаунта.',
      'Сервис не направляет рекламные сообщения по электронной почте или в Telegram без отдельного согласия Пользователя.'
    ]
  },
  {
    heading: '4. Изображения и AI-обработка',
    paragraphs: [
      'Загруженные изображения обрабатываются исключительно для выполнения запросов Пользователя и предоставления результатов генерации.',
      'Если Пользователь загружает изображения, содержащие лица людей, Пользователь подтверждает наличие необходимых правовых оснований для использования таких изображений.',
      'Сервис не осуществляет идентификацию личности по изображениям и не использует технологии распознавания лиц.',
      'Для выполнения отдельных операций Сервис может использовать внешние технические сервисы и AI-инструменты. Передача материалов осуществляется только в объеме, необходимом для обработки конкретного задания Пользователя.',
      'Сервис не требует загружать персональные данные, документы, платежные реквизиты, конфиденциальную информацию или материалы третьих лиц. Пользователь самостоятельно отвечает за содержание загружаемых материалов и подтверждает, что имеет право использовать их в Сервисе.'
    ]
  },
  {
    heading: '5. Технические сервисы',
    paragraphs: [
      'Для работы отдельных функций Сервис может использовать внешние технические сервисы: авторизацию, оплату, аналитику, хранение файлов, генерацию и обработку изображений.',
      'Передача информации таким сервисам осуществляется только в объеме, необходимом для предоставления соответствующей функции, проведения оплаты, обеспечения безопасности или выполнения требований законодательства.',
      'Загруженные материалы и параметры задания могут передаваться для обработки только в рамках конкретного запроса Пользователя.'
    ]
  },
  {
    heading: '6. Cookies и аналитика',
    paragraphs: [
      'Сервис может использовать cookies и аналогичные технологии для обеспечения работы сайта, сохранения пользовательских настроек и повышения безопасности.',
      'Для анализа посещаемости и улучшения работы Сервиса используется Яндекс.Метрика. В аналитику передаются сведения о посещении страниц, действиях в интерфейсе, характеристиках браузера и устройства, а также обезличенные сведения о событиях. Сервис не передает в Метрику содержимое изображений, текстовых запросов, адреса электронной почты или идентификаторы платежей.',
      'Пользователь может ограничить использование cookies через настройки своего браузера.'
    ]
  },
  {
    heading: '7. Сроки и место хранения данных',
    paragraphs: [
      'Загруженные изображения и результаты генерации могут временно храниться в инфраструктуре Сервиса.',
      'Загруженные изображения и результаты генерации обычно хранятся 60 дней и автоматически удаляются после истечения срока хранения. При повторном использовании входного изображения срок его хранения может быть продлен на очередные 60 дней, чтобы Пользователь мог продолжить работу с проектом.',
      'Удаление файла из хранилища не всегда означает немедленное удаление связанных технических записей: минимальные сведения об операции могут сохраняться для учета, безопасности и разрешения спорных ситуаций.',
      'Отдельные данные могут храниться дольше, если это необходимо для обеспечения безопасности Сервиса, разрешения спорных ситуаций или соблюдения требований законодательства.'
    ]
  },
  {
    heading: '8. Защита данных',
    paragraphs: [
      'Администрация принимает разумные организационные и технические меры для защиты информации Пользователей.',
      'При этом абсолютная безопасность передачи данных через интернет не может быть гарантирована.'
    ]
  },
  {
    heading: '9. Удаление данных',
    paragraphs: [
      'Пользователь вправе обратиться в поддержку с запросом на удаление своих данных.',
      'Запрос можно направить на адрес support@fravai.com. Пользователь также может обратиться по вопросам уточнения данных, ограничения обработки или изменения способа получения необязательных технических уведомлений. В отдельных случаях часть информации может быть сохранена на срок, необходимый для исполнения обязательств, разрешения споров, защиты прав Сервиса или соблюдения требований законодательства.'
    ]
  },
  {
    heading: '10. Пользователи младше 18 лет',
    paragraphs: [
      'Сервис предназначен для пользователей старше 18 лет.',
      'Если Администрации станет известно, что данные несовершеннолетнего были получены без согласия законного представителя, такие данные могут быть удалены.'
    ]
  },
  {
    heading: '11. Изменение Политики',
    paragraphs: [
      'Администрация вправе вносить изменения в настоящую Политику. Актуальная редакция всегда доступна на данной странице.'
    ]
  }
]


export default function PrivacyPage() {
  return (
    <>
      <Seo
        title="Политика конфиденциальности"
        description="Узнайте, как Fravai собирает, хранит и использует персональные данные пользователей сервиса нейроретуши."
        canonical="/legal/privacy"
        keywords={['политика конфиденциальности', 'Fravai', 'обработка персональных данных']}
        openGraph={{ type: 'article', image: { url: DEFAULT_OG_IMAGE, alt: 'Fravai — политика конфиденциальности' } }}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Политика конфиденциальности Fravai',
          url: 'https://fravai.com/legal/privacy',
          inLanguage: 'ru-RU',
          isPartOf: { '@type': 'WebSite', name: 'Fravai', url: 'https://fravai.com/' },
        }}
      />
      <main
        style={{
          maxWidth: 860,
          margin: '0 auto',
          padding: '32px 20px 56px',
          lineHeight: 1.6,
          fontFamily: 'Inter, Arial, sans-serif',
          color: '#101828',
          background: '#fff',
        }}
      >
        <Link
          to="/"
          style={{
            display: 'inline-block',
            marginBottom: 20,
            color: '#1d4ed8',
            textDecoration: 'none',
            fontSize: 20,
          }}
        >
          ← На главную
        </Link>

        <h1 style={{ fontSize: 32, margin: '0 0 20px', lineHeight: 1.25 }}>Политика конфиденциальности</h1>
        <p style={{ margin: '0 0 20px', color: '#667085' }}>
          Редакция {POLICY_VERSION}, действует с {POLICY_EFFECTIVE_DATE}
        </p>

        {sections.map((section) => (
          <section key={section.heading}>
            <h2 style={{ fontSize: 20, margin: '28px 0 12px', lineHeight: 1.3 }}>{section.heading}</h2>
            {section.paragraphs.map((text, idx) => (
              <p key={idx} style={{ margin: '0 0 10px', color: '#344054' }}>
                {text}
              </p>
            ))}
          </section>
        ))}

        <section>
          <h2 style={{ fontSize: 20, margin: '28px 0 12px', lineHeight: 1.3 }}>12. Связь по вопросам обработки данных</h2>
          <p style={{ margin: '0 0 10px', color: '#344054' }}>
            Если у вас есть вопросы, напишите нам на адрес{' '}
            <a href="mailto:support@fravai.com" style={{ color: '#1d4ed8' }}>
              support@fravai.com
            </a>{' '}
            — мы ответим и поможем реализовать ваши права.
          </p>
        </section>
      </main>
    </>
  )
}
